import { render, staticRenderFns } from "./NewCandidateDashboard.vue?vue&type=template&id=9466de02&scoped=true"
import script from "./NewCandidateDashboard.vue?vue&type=script&lang=js"
export * from "./NewCandidateDashboard.vue?vue&type=script&lang=js"
import style0 from "./NewCandidateDashboard.vue?vue&type=style&index=0&id=9466de02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9466de02",
  null
  
)

export default component.exports